import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "./_utils";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({
  className,
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          // Ink-dark solid stays; only geometry and elevation are tokenized.
          "z-50 overflow-hidden rounded-[var(--radius-control)] bg-text-primary text-text-inverse " +
            "px-sm py-xs text-sm shadow-[var(--shadow-control)]",
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}

/**
 * Tooltip built on Radix Tooltip. Requires a `<TooltipProvider>` ancestor
 * (mounted once in `App.tsx`).
 *
 * @example
 * <Tooltip>
 *   <TooltipTrigger asChild><Button>Save</Button></TooltipTrigger>
 *   <TooltipContent>Saves the document</TooltipContent>
 * </Tooltip>
 */
